import { Controller } from "@hotwired/stimulus"

// Pokazuje/ukrywa kontener źródła alertów zależnie od rodzaju: ticket wymaga deska,
// zadanie projektu. Initial state ustawia ERB klasą "hidden", JS przejmuje przy zmianie selecta.
export default class extends Controller {
  static targets = ["kindSelect", "deskField", "projectField"]

  connect() {
    this.toggle()
  }

  // Przy zmianie rodzaju czyścimy pole ukrywanego kontenera - inaczej w bazie zostałby
  // martwy desk_id/project_id, którego formularz i widok już nie pokazują.
  // Przy pierwszym renderze (connect) nie czyścimy, żeby samo otwarcie edycji nic nie zmieniało.
  toggle(event) {
    const kind = this.kindSelectTarget.value
    this.toggleField(this.hasDeskFieldTarget && this.deskFieldTarget, kind === "ticket", event)
    this.toggleField(this.hasProjectFieldTarget && this.projectFieldTarget, kind === "task", event)
  }

  toggleField(field, visible, event) {
    if (!field) return

    field.classList.toggle("hidden", !visible)
    if (visible || !event) return

    field.querySelectorAll("select, input").forEach((input) => { input.value = "" })
  }
}
